<template>
  <div style="display: none"></div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useGoogleTagManagerStore } from '@/stores/google-tag-manager'

const googleTagManagerStore = useGoogleTagManagerStore()

try {
  const scriptContent = googleTagManagerStore.getScriptContent()

  if (scriptContent && typeof scriptContent === 'string' && scriptContent.trim()) {
    useHead({
      script: [
        {
          innerHTML: scriptContent,
          key: 'google-tag-manager'
        }
      ]
    })
  }
} catch (error) {
  console.error('Failed to inject Google Tag Manager script:', error)
}
</script>
